<template>
  <div class="user-registration-button_box" v-if="!isLogin">
    <router-link class="client_dm" :to="{ name: 'RegistrationUser'}">
      <img class='base_image' src='@/assets/image/pages/top/button_h.png'>
    </router-link>
    <router-link :to="{ name: 'RegistrationUser'}">
      <img class='base_image' src='@/assets/image/pages/top/button_j.png'>
    </router-link>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "UserRegistrationButtonBox",

    computed: {
      ...mapGetters({isLogin: 'auth/isLogin'}),
    },
  }
</script>

<style lang="scss" scoped>
  .user-registration-button_box {
    display: flex;
    justify-content: center;

    > a > .base_image {
      width: 15rem;
    }

    > .client_dm {
      margin-right: 2rem;
    }
  }
</style>